<zdb-main-layout>
  <zdb-card>
    <div class="card-body">
      <router-outlet></router-outlet>
    </div>
  </zdb-card>
</zdb-main-layout>
